/**
 * App Store Module Routes Configuration
 * Defines all routes for the app store module
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import Layout from '../../../../components/Layout';
import PrivateRoute from '../../../../components/PrivateRoute';

// Pages
import Dashboard from '../pages/Dashboard';
import AppList from '../pages/AppList';
import AppDetails from '../pages/AppDetails';
import MyApps from '../pages/MyApps';

/**
 * App Store route configuration
 * Note: Routes are currently public (no authentication required)
 */
export const appStoreRoutes: RouteObject[] = [
  {
    path: '/app/appstore',
    element: <PrivateRoute><Layout /></PrivateRoute>,
    children: [
      {
        index: true,
        element: <AppList />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'apps',
        element: <AppList />
      },
      {
        path: 'apps/:appId',
        element: <AppDetails />
      },
      {
        path: 'app/:appId',
        element: <AppDetails />
      },
      {
        path: 'my-apps',
        element: <MyApps />
      }
    ]
  }
];

export default appStoreRoutes;
